<template>
  <v-container id="info__content">
    <h1></h1>
    <nav-back-component/>
    <h1>
      {{$t('imprint.title')}}
    </h1>

    <h2>
      {{$t('imprint.publisher')}}
    </h2>

    <h3>
      {{$t('imprint.institute')}}
    </h3>

    <div>
      <p>Ackerstrasse 113 / {{$t('imprint.postBox')}} 219</p>
      <p>CH-5070 Frick</p>
      <p>{{$t('imprint.telephone')}} +41 62 8657-272</p>
      <p>info.suisse(at)fibl.org</p>
      <p><a href="https://www.fibl.org">www.fibl.org</a></p>
    </div>

    <div>
      <p>{{$t('imprint.director')}}: Knut Schmidtke</p>
      <p>{{$t('imprint.uid')}}: CHE-107.938.089</p>
      <p>{{$t('imprint.tax')}}: CHE-107.938.089 {{$t('imprint.vat')}}</p>
    </div>

    <h4>{{$t('imprint.contact')}}:</h4>
    <div>
      <p>Dr. Else Bünemann</p>
      <p>Senior Scientist</p>
      <p>Research Institute of Organic Agriculture FiBL</p>
      <p>Ackerstrasse 113</p>
      <p>5070 Frick</p>
      <p>Switzerland</p>
      <p>Phone: +41 62 865 0482</p>
      <p>else.buenemann(at)fibl.org</p>
      <p><a href="https://www.fibl.org">www.fibl.org</a></p>
    </div>

    <h4>{{$t('imprint.authors.title')}}:</h4>
    <div>
      This web-application was developed by Dr. Else Bünemann-König (FiBL) and Marie Reimer 
      (University of Hohenheim) in the frame of the project “Replacement of Contentious Inputs 
      in Organic Farming Systems’ (RELACS) which has received funding from the 
      European Union’s Horizon 2020 research and innovation programm under grant 
      agreement No 773431.
    </div>

    <h4>{{$t('imprint.implementation')}}:</h4>
    <div>
      <a href="https://www.karakun.com">Karakun GmbH</a>
    </div>


    <h2>{{$t('imprint.copyright.title')}}</h2>
    <div>
      {{$t('imprint.copyright.text')}}
    </div>

    <h2>{{$t('imprint.disclaimer.title')}}</h2>
    <div>
      {{$t('imprint.disclaimer.text')}}
    </div>

    <h2>{{$t('imprint.externalLinks.title')}}</h2>
    <div>
      {{$t('imprint.externalLinks.text')}}
    </div>
  </v-container>
</template>

<script>
import NavBackComponent from '../components/NavBackComponent.vue'
export default {
  components: { NavBackComponent },

}
</script>
